import styled from 'styled-components';

export const LanguageRow = styled.div`
  margin-bottom: var(--margin-lg);
  .ant-space-item:first-child {
    width: 100%;
  }
`;
